import React from "react";
import Box from "@amzn/meridian/box";
import Button from "@amzn/meridian/button";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import { useNavigate } from "react-router-dom";
import Column from "@amzn/meridian/column";
import { Space } from "../space/Space";
import { IMailAlertsProps } from "./definitions";

export const MailAlerts: React.FC<IMailAlertsProps> = ({ title, description, detailsLink }) => {
    const navigate = useNavigate();

    return (
        <Column width={"'100%"}>
            <Space size={"xxs"} />
            <Box backgroundColor={"principal"} type="outline">
                <Row width="100%" widths={["fill", "fit"]} spacing="400">
                    <Box spacingInset={"400"}>
                        <Text type={"h300"}> {title}</Text>
                        <Space size={"xxs"} />
                        <Text>{description}</Text>
                    </Box>
                    <Button
                        onClick={() => navigate(detailsLink ?? "")}
                        size={"small"}
                        type={"secondary"}
                    >
                        View details
                    </Button>
                    <Space size={"xxs"} />
                </Row>
            </Box>
            <Space size={"xs"} />
        </Column>
    );
};
